var _path, _rect, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlideIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0886 9.48968C10.1691 9.5693 10.2143 9.67729 10.2143 9.78989C10.2143 9.90248 10.1691 10.0105 10.0886 10.0901C10.0081 10.1697 9.89898 10.2144 9.78518 10.2144C9.67137 10.2144 9.56223 10.1697 9.48175 10.0901L6.62599 7.26464C6.58606 7.22527 6.55437 7.17848 6.53275 7.12697C6.51113 7.07545 6.5 7.02022 6.5 6.96444C6.5 6.90866 6.51113 6.85343 6.53275 6.80191C6.55437 6.7504 6.58606 6.70361 6.62599 6.66424L9.48175 3.83879C9.56223 3.75917 9.67137 3.71444 9.78518 3.71444C9.89898 3.71444 10.0081 3.75917 10.0886 3.83879C10.1691 3.91841 10.2143 4.02639 10.2143 4.13899C10.2143 4.25159 10.1691 4.35958 10.0886 4.4392L7.53662 6.96409L10.0886 9.48968Z",
    fill: "#E2E3E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.371429,
    y: 0.371429,
    width: 12.2571,
    height: 12.2571,
    rx: 0.928571,
    stroke: "#E2E3E9",
    strokeWidth: 0.742857
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.25091,
    x2: 3.25091,
    y2: 13,
    stroke: "#E2E3E9",
    strokeWidth: 0.928571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideIn);
export default __webpack_public_path__ + "static/media/Slide_in.bee1b9268e50dfb282129d56b79ea3cf.svg";
export { ForwardRef as ReactComponent };